module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('ul', {
    staticClass: "timeline"
  }, _vm._l((_vm.timeline), function(event) {
    return _c('li', {
      staticClass: "event-container"
    }, [_c(event.type, {
      tag: "component",
      attrs: {
        "event": event
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e17d7cd"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/timeline/Timeline.vue
// module id = 2017
// module chunks = 1